import styles from '../Header.module.css';
import Redirects from "@/commons/utils/Redirects";

const HeaderButton = ({ title, link, domain, type }) => {

    const handleClick = (e) => {
        if (!link) {
            if (domain) Redirects.domainSendClick(domain, link, e);
            return;
        }
        Redirects.send(link, e);
    };

    const hasDomain = () => domain && domain !== "";

    const isPage = () => {
        if (link && document.location.pathname.toLowerCase().startsWith(link.toLowerCase())) {
            return !hasDomain();
        }
        return false;
    };

    const getClassName = () => {
        if (type === "evidenced") return `${styles.headerButton} ${styles.headerEvidenced}`;
        if (isPage()) return `${styles.headerButton} ${styles.headerActive}`;
        return styles.headerButton;
    };

    return (
        <div className={getClassName()} onClick={handleClick}>
            {title}
        </div>
    );
};

export default HeaderButton;